// extracted by mini-css-extract-plugin
export default {"btnWrapper":"backToTopButton_btnWrapper__PLQbA","text":"backToTopButton_text__daCru"};